import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import PracticalAiAutomationForModernBusinesses from "./sections/PracticalAiAutomationForModernBusinesses";
import TheDatazenAdvantage from "./sections/TheDatazenAdvantage";
import OurAutomationSuite from "./sections/OurAutomationSuite";
import ThePathToEfficiency from "./sections/ThePathToEfficiency";
import SeeDatazenInAction from "./sections/SeeDatazenInAction";
import TheVisionBehindTheZen from "./sections/TheVisionBehindTheZen";
import ReadyToAutomate from "./sections/ReadyToAutomate";
import ContactGetInTouch from "./sections/ContactGetInTouch";
import StartYourTransformation from "./sections/StartYourTransformation";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Header />
      <PracticalAiAutomationForModernBusinesses />
      <TheDatazenAdvantage />
      <OurAutomationSuite />
      <ThePathToEfficiency />
      <SeeDatazenInAction />
      <TheVisionBehindTheZen />
      <ReadyToAutomate />
      <ContactGetInTouch />
      <StartYourTransformation />
      <Footer />
    </div>;
}